import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { switchMap, take, tap } from 'rxjs/operators';
import { User } from '../../shared/models';
import { CustomerAccountTypes } from '../../shared/models/customer-account-types';
import { SessionService } from '../../shared/session.service';
import { TokenExchangeService } from '../../shared/token-exchange.service';
import { AccountService } from '../account.service';
import { CustomerAccountService } from '../../shared/customer-account.service';

@Component({
  selector: 'app-external-access-landing-page',
  templateUrl: './external-access-landing-page.component.html',
  styleUrl: './external-access-landing-page.component.scss'
})
export class ExternalAccessLandingPageComponent implements OnInit {
  customerAccountTypes = CustomerAccountTypes;
  loading = false;
  user: User;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private customerAccountService: CustomerAccountService,
    private sessionService: SessionService,
    private tokenExchangeService: TokenExchangeService,
  ) { }

  ngOnInit(): void {
    this.loading = true;
    const yToken = this.route.snapshot.queryParams['y'];

    this.sessionService.hasSession.pipe(
      take(1),
      switchMap(hasSession => {
        if (hasSession) {
          return this.sessionService.account;
        }

        return this.tokenExchangeService.exchange().pipe(
          switchMap(() => this.accountService.default(yToken)),
          switchMap(accountId => this.accountService.account(accountId)),
          tap(account => this.sessionService.setAccount(account))
        );
      }),
      switchMap(account => this.customerAccountService.credentialsRequired(account.id)),
      take(1)
    ).subscribe(credentialsRequired => {
        if (!credentialsRequired) {
          this.router.navigateByUrl('accounts');
          return;
        }

        this.loading = false;
      },
      () => this.router.navigateByUrl('log-out')
    );
  }

  credentialsProvided(): void {
    this.sessionService.account.pipe(
      switchMap(account => this.customerAccountService.credentialsProvided(account.id)),
      take(1)
    ).subscribe(
      () => {
        this.router.navigateByUrl('accounts');
      }
    );
  }
}
